import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SsoService {

  constructor(
    private http: HttpClient
  ) {
  }

  getSsoByYear(year: number): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/social_security/${year}`);
  }

  updateSso(body: any): Observable<any> {
    return this.http.put(`${environment.apiBaseUrl}/social_security/update`, body);
  }
}
